import { StsEmployeeInfo } from '@c42/jwt/dist/constants';
import React from 'react';

export type SupportLoginData = {
  accessType?: string;
  employeeInfo?: StsEmployeeInfo;
  isEmployeeInfoError: boolean;
  isFetchingEmployeeInfo: boolean;
  isFetchingJwt: boolean;
  isFetchingTenantName: boolean;
  isJwtError: boolean;
  isTenantNameError: boolean;
  tenantId?: string;
  tenantName?: string;
};

export const DEFAULT_SUPPORT_LOGIN_DATA: SupportLoginData = {
  isEmployeeInfoError: false,
  isFetchingEmployeeInfo: false,
  isFetchingJwt: false,
  isFetchingTenantName: false,
  isJwtError: false,
  isTenantNameError: false,
};

type SupportLoginDataContextValue = {
  supportLoginData: SupportLoginData;
  setSupportLoginData: React.Dispatch<React.SetStateAction<SupportLoginData>>;
};

export const SuportLoginDataContext = React.createContext<SupportLoginDataContextValue>({
  supportLoginData: DEFAULT_SUPPORT_LOGIN_DATA,
  setSupportLoginData: () => null,
});
